import { render, staticRenderFns } from "./EnvizionLoader.vue?vue&type=template&id=afb385ac&scoped=true"
import script from "./EnvizionLoader.vue?vue&type=script&lang=js"
export * from "./EnvizionLoader.vue?vue&type=script&lang=js"
import style0 from "./EnvizionLoader.vue?vue&type=style&index=0&id=afb385ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb385ac",
  null
  
)

export default component.exports